(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["byo-proxy"] && !Shopify.designMode) return;
  try {
    
gsap.registerPlugin(ScrollTrigger)
let mm = gsap.matchMedia()
mm.add({
  isDesktop: `(min-width: 1024px)`,
  isTablet: `(min-width: 767px)`,
  isMobile: `(max-width: 767px)`,
}, (context) => {
  let { isDesktop, isTablet, isMobile } = context.conditions
 
  gsap.utils.toArray('.byo-proxy').forEach((byoProxy) => {
    gsap.to('.pipes', { xPercent: 5 })
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: byoProxy,
        scrub: isMobile ? 2 : 0.3,
        start: "center center",
        end: () => "+=" + byoProxy.offsetWidth,
        pin: byoProxy,
      },
    });
    if (isDesktop || isTablet) {
      tl.to('.base', {y: '20%'})
        .to('.base', {y: isDesktop ? '-5%' : '-2%'})
        .to('.pipes', {x: isTablet ? '-33.333%' : '-100%'}, 1)
        .to('.base', {x: '100%'}, 1)
        .to('.base', {y: '20%'})
        .to('.base', {y: isDesktop ? '-5%' : '-2%'})
        .to('.pipes', {x: isTablet ? '-66.666%' : '-100%'}, 3)
        .to('.base', {x: '200%'}, 3)
        .to('.base', {y: '20%'})
    }
    if (isMobile) {
      tl.to('.base', {y: '20%'})
        .to('.base', {y: '-2%'})
        .to('.pipes', {x: '-100%'}, 1)
        .to('.base', {x: '100%'}, 1)
        .to('.base', {y: '20%'})
        .to('.base', {y: '-2%'})
        .to('.pipes', {x: '-200%'}, 3)
        .to('.base', {x: '200%'}, 3)
        .to('.base', {y: '20%'})
    }
  })
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-chart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('comparison-chart')) {
    customElements.define(
      'comparison-chart',
      class ComparisonChart extends HTMLElement {
        constructor() {
          super()
          this.hiddenElements = this.querySelectorAll('[data-hidden-item]')
          this.expandBtn = this.querySelector('[data-expand-btn]')
          if(this.expandBtn) {
            this.expandBtn.addEventListener('click', () => {
              const svg = this.querySelector('.icon-caret')
              if(svg.classList.contains('rotate-180')) {
                svg.classList.remove('rotate-180')
                this.hiddenElements.forEach((element) => {
                  element.classList.add('!hidden')
                })
                this.expandBtn.querySelector('span').innerHTML = 'View Full Comparison Chart'
              } else {
                svg.classList.add('rotate-180')
                this.hiddenElements.forEach((element) => {
                  element.classList.remove('!hidden')
                })
                this.expandBtn.querySelector('span').innerHTML = 'Minimize Comparison Chart'
              }
              this.adjustHeights()
            })
          }
          this.headers = this.querySelectorAll('[data-header]')
          this.lines = this.querySelectorAll('[data-child-line]')
          this.adjustHeights()
          window.addEventListener('resize', () => {
            this.adjustHeights()
          })
        }
        adjustHeights() {
          this.headers.forEach((header, index) => {
            header.style.height = 'auto'
            this.lines[index].style.height = 'auto'
            const newHeight = Math.max(header.offsetHeight, this.lines[index].offsetHeight)
            header.style.height = `${newHeight}px`
            this.lines[index].style.height = `${newHeight}px`
          })
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('feature-cards')) {
    customElements.define(
      'feature-cards',
      class FeatureCards extends HTMLElement {
        constructor() {
          super()
          this.enableAnimation = (this.dataset.animation === 'true' || this.dataset.animation === true)
          this.cards = this.querySelector('.cards')
          this.card = this.querySelectorAll('.card')
          this.initEvents()
        }
        initEvents() {
          if (this.enableAnimation) {
            gsap.registerPlugin(ScrollTrigger)
            const cards = gsap.utils.toArray(this.card);
            let stickDistance = 500; // extra distance to have things stick after the last card pins (pixels)
            // create a ScrollTrigger that's solely for the purpose of figuring out when the LAST card's center hits the center of the viewport so we can use that to calculate the end positions of the other card ScrollTriggers
            let lastCardST = ScrollTrigger.create({
              trigger: cards[cards.length-1],
              start: 'center center'
            });

            cards.forEach((card, i) => {
              gsap.to(card, {
                scrollTrigger: {
                  trigger: card,
                  start: 'center center',
                  end: () => lastCardST.start + stickDistance,
                  pin: true,
                  pinSpacing: false,
                  snap: {
                    snapTo: card, // snap to the closest label in the timeline
                    duration: { min: 0.2, max: 1 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
                    delay: 2, // wait 0.2 seconds from the last scroll event before doing the snapping
                    ease: "power1" // the ease of the snap animation ("power3" by default)
                  },
                  toggleActions: 'play none none reverse'
                },
                ease: "none",
                opacity: 1
              });
            });
          }
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flex-bundles-toad"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pdp-images')) {
  customElements.define(
    'pdp-images',
    class PdpImages extends HTMLElement {
      constructor() {
        super()
        this.initSwipers()
      }
      initSwipers() {
        if(this.swiper) this.swiper.destroy(true, true)
        if(this.thumbs) this.swiper.destroy(true, true)
        this.thumbs = new Swiper (this.querySelector('[data-thumb-swiper]'), {
          slidesPerView: 'auto',
          spaceBetween: 16,
          slideToClickedSlide: true,
        })
        this.swiper = new Swiper(this.querySelector('[data-media-swiper]'), {
          grabCursor: true,
          slidesPerView: 1,
          autoHeight: true,
          thumbs: {
            swiper: this.thumbs
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          }
        })
      }
    },
  )
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('pdp-images')) {
  customElements.define(
    'pdp-images',
    class PdpImages extends HTMLElement {
      constructor() {
        super()
        this.initSwipers()
      }
      initSwipers() {
        if(this.swiper) this.swiper.destroy(true, true)
        if(this.thumbs) this.swiper.destroy(true, true)
        this.thumbs = new Swiper (this.querySelector('[data-thumb-swiper]'), {
          slidesPerView: 'auto',
          spaceBetween: 16,
          slideToClickedSlide: true,
        })
        this.swiper = new Swiper(this.querySelector('[data-media-swiper]'), {
          grabCursor: true,
          slidesPerView: 1,
          autoHeight: true,
          thumbs: {
            swiper: this.thumbs
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          }
        })
      }
    },
  )
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-gallery"] && !Shopify.designMode) return;
  try {
    

const thumbnails = new Swiper(".media-gallery", {
  direction: "horizontal",
  slidesPerView: 3,
  loop: true,
  spaceBetween: 40,
  pagination: false,
  freeMode: true,
  breakpoints: {
    480: {
      direction: "horizontal",
      slidesPerView: 3,
      freeMode: true
    },
    1024: {
      direction: "vertical",
      slidesPerView: 3,
      spaceBetween: 0
    },
  }
});

const focusView = new Swiper(".media-gallery-focus-view", {
  loop: true,
  spaceBetween: 10,
  thumbs: {
    swiper: thumbnails,
  },
  freeMode: false,
  breakpoints: {
    // when window width is >= 320px
    0: {
      pagination: {
        el: ".media-gallery-pagination",
        centeredSlides: true,
        clickable: true,
        renderBullet: function renderPagination(index, className) {
          return '<svg class="' + className + '" width="25" height="3" viewBox="0 0 25 3" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="25" height="3" rx="1.5" fill="#B3B3B3"/></svg>';
        }
      }
    },
    480: {
      pagination: {
        el: ".media-gallery-pagination",
        centeredSlides: true,
        clickable: true,
        renderBullet: function renderPagination(index, className) {
          return '<svg class="' + className + '" width="88" height="3" viewBox="0 0 88 3" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="88" height="3" rx="1.5" fill="#B3B3B3"/></svg>'
        }
      }
    }
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text"] && !Shopify.designMode) return;
  try {
    
  gsap.registerPlugin(ScrollTrigger)
  gsap.set('.media-with-text .content', { yPercent: '60', opacity: 0 })

  gsap.utils.toArray('.media-with-text').forEach((mediaWithText) => {
    const content = mediaWithText.querySelector('.media-with-text .content')
    gsap.to(content, {
      yPercent: 0,
      opacity: 1,
      stagger: {
        amount: 0.5
      },
      scrollTrigger: {
        trigger: mediaWithText,
        toggleActions: 'play none none reverse',
        start: '-20% +30%',
        end: '80% bottom',
      },
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mission-statement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mission-statement')) {
    customElements.define(
      'mission-statement',
      class MissionStatement extends HTMLElement {
        constructor() {
          super()
          
          this.videos = this.querySelectorAll('[data-video]')
          this.autplay = parseInt(this.querySelector('[data-media-swiper]').dataset.autoplay)
          this.swiper = new Swiper(this.querySelector('[data-media-swiper]'), {
            grabCursor: true,
            autoplay: {
              delay: this.autplay * 1000,
              disableOnInteraction: false,
            },
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            },
            pagination: {
              el: '.swiper-pagination',
              renderBullet: function (index, className) {
                return `<span class="text-puffco-grey-3 w-7 text-16 h-7 inline-flex items-center justify-center font-bold !mx-2 cursor-pointer bg-transparent opacity-100 ${className}">${index + 1}</span>`;
              },
              clickable: true,
            },
          })
          
          this.swiper.on('slideChange', (args) => {
            this.videos.forEach((video) => video.pause())
            setTimeout(() => {
              const video = args.el.querySelector('.swiper-slide-active [data-video]')
              if(video) video.play()
            }, 500)
          })
          if(this.querySelector('[data-slide]:first-child video')) this.querySelector('[data-slide]:first-child video').play()
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-block"] && !Shopify.designMode) return;
  try {
    
  let newsBlockSwipers = document.querySelectorAll('.news-block-swiper')
  const newsBlockSwiperItems = [...newsBlockSwipers].map((swiper, i) => {
    swiper.classList.add('news-block-swiper' + i)
    return new Swiper('.news-block-swiper' + i, {
      direction: 'horizontal',
      loop: true,
      spaceBetween: 60,
      loopedSlides: 2000,
      allowTouchMove: false,
      simulateTouch: false,
      speed: 2000,
      autoplay: {
        delay: 1,
        reverseDirection: false,
        disableOnInteraction: false,
      },
      slidesPerView: 3,
      freeMode: {
        enabled: true,
        momentum: false
      },
      breakpoints: {
        640: {
          slidesPerView: 8
        }
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overview-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('overview-cards')) {
    customElements.define(
      'overview-cards',
      class OverviewCards extends HTMLElement {
        constructor() {
          super()
          this.enableAnimation = (this.dataset.animation === 'true' || this.dataset.animation === true)
          this.cards = this.querySelector('.cards')
          this.card = this.querySelectorAll('.card')
          this.initEvents()
        }

        initEvents() {
          if(this.enableAnimation) {
            gsap.registerPlugin(ScrollTrigger)
            this.initWidgets()
          }
        }

        initWidgets() {
          let mm = gsap.matchMedia()

          mm.add("(min-width: 768px)", () => {
            const cards = gsap.utils.toArray(this.card);
            let stickDistance = 0; // extra distance to have things stick after the last card pins (pixels)
            // create a ScrollTrigger that's solely for the purpose of figuring out when the LAST card's center hits the center of the viewport so we can use that to calculate the end positions of the other card ScrollTriggers
            let lastCardST = ScrollTrigger.create({
              trigger: cards[cards.length-1],
              start: 'center center'
            });

            cards.forEach((card, i) => {
              ScrollTrigger.create({
                trigger: card,
                start: 'center center',
                end: () => lastCardST.start + stickDistance,
                pin: true,
                pinSpacing: false
              });
            });
          });

          mm.add("(max-width: 767px)", () => {
            const cards = gsap.utils.toArray(this.card);
            const spacer = 20;
            const minScale = 0.8;

            const distributor = gsap.utils.distribute({ base: minScale, amount: 0.2 });

            cards.forEach((card, index) => {

              const scaleVal = distributor(index, cards[index], cards);

              gsap.to(card, {
                scrollTrigger: {
                  trigger: card,
                  start: 'top 40%',
                  scrub: true,
                  invalidateOnRefresh: true
                },
                ease: "none",
                scale: scaleVal,
                opacity: scaleVal
              });

              ScrollTrigger.create({
                trigger: card,
                start: `top-=${index * spacer} top`,
                endTrigger: this.cards,
                end: `bottom top+=${600 + (cards.length * spacer)}`,
                pin: true,
                pinSpacing: false,
                invalidateOnRefresh: true
              });
            });
          });
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-light-up"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-lightup')) {
    customElements.define(
      'pdp-lightup',
      class PdpLightup extends HTMLElement {
        constructor() {
          super()
          this.video = this.querySelector('[data-video]')
          this.buttons = this.querySelectorAll('[data-btn]')
          this.buttons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
              const target = e.target.className === 'BUTTON' ? e.target : e.target.closest('button')
              const videoData = JSON.parse(target.dataset.btn)
 
              let videoHtml = '<video class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full object-contain lg:object-cover" width="320" height="240" playsinline muted loop autoplay>'
              videoData.sources.forEach((source) => {
                videoHtml += `<source src="${source.url}" type="${source.mime_type}">`
              })
              videoHtml += 'Your browser does not support the video tag.'
              videoHtml += '</video>'
              this.video.innerHTML = videoHtml
              this.buttons.forEach((b) => {
                if(b === target)
                  b.querySelector('img').classList.add('border', 'border-white')
                else
                  b.querySelector('img').classList.remove('border', 'border-white')
              })
            })
          })
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();
})();
